import { render, staticRenderFns } from "./CertificateTemplate.vue?vue&type=template&id=1a194ea7&scoped=true&"
import script from "./CertificateTemplate.vue?vue&type=script&lang=js&"
export * from "./CertificateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CertificateTemplate.vue?vue&type=style&index=0&id=1a194ea7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a194ea7",
  null
  
)

export default component.exports